import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c9a55d82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-row items-center py-2 container"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-200" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 2,
  class: "py-8 flex flex-row items-center container w-full"
}
const _hoisted_7 = { class: "flex flex-row ml-4 bg-white w-full" }
const _hoisted_8 = { class: "space-y-5 w-full" }
const _hoisted_9 = { class: "sm:flex flex-row items-center justify-between w-full" }
const _hoisted_10 = { class: "text-2xl" }
const _hoisted_11 = { class: "flex flex-row items-center" }
const _hoisted_12 = { class: "flex items-center pr-5" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "View job page ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Edit job", -1))
const _hoisted_15 = { class: "sm:flex sm:justify-center items-center" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "text-xs sm:text-xs font-bold text-center mx-auto" }
const _hoisted_18 = { class: "px-3" }
const _hoisted_19 = { class: "block mx-auto h-8 bg-gray-100 text-center text-xs p-2 rounded" }
const _hoisted_20 = { class: "flex-grow bg-background shadow-inner min-h-screen h-full" }
const _hoisted_21 = { class: "container py-8" }
const _hoisted_22 = { class: "sm:flex space-x-5 space-y-6 sm:space-y-0" }
const _hoisted_23 = { class: "card-main h-screen sm:w-1/3 justify-between items-start overflow-y-auto" }
const _hoisted_24 = {
  key: 0,
  class: "h-96 pt-3"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "p-3" }
const _hoisted_27 = { class: "p-1 space-y-1" }
const _hoisted_28 = { class: "block text-xs font-bold" }
const _hoisted_29 = { class: "flex flex-row items-center" }
const _hoisted_30 = { class: "text-xs text-gray-400" }
const _hoisted_31 = {
  key: 0,
  class: "flex flex-row items-center"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-px bg-gray-300 mx-4" }, null, -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = {
  key: 1,
  class: "p-5"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-primary text-lg" }, "There are no candidates yet in this job stage.", -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = {
  key: 0,
  class: "sm:w-2/3"
}
const _hoisted_38 = {
  key: "create-div",
  class: "sm:w-2/3"
}
const _hoisted_39 = {
  key: 2,
  class: "sm:w-2/3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Button = _resolveComponent("Button")!
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_CandidateInfo = _resolveComponent("CandidateInfo")!
  const _component_AddCandidatesForm = _resolveComponent("AddCandidatesForm")!
  const _component_ReusableModal = _resolveComponent("ReusableModal")!
  const _component_DeleteCandidate = _resolveComponent("DeleteCandidate")!
  const _component_AddCandidatesInJob = _resolveComponent("AddCandidatesInJob")!
  const _component_AddTemplateToJob = _resolveComponent("AddTemplateToJob")!
  const _component_ModalUpgradePlan = _resolveComponent("ModalUpgradePlan")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Header),
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
        : _createCommentVNode("", true),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_Loading, {
              active: _ctx.isLoading,
              "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event)),
              "can-cancel": false,
              loader: "spinner",
              color: "#8908F9",
              width: 128,
              height: 128,
              opacity: 0.5,
              "is-full-page": true
            }, null, 8, ["active", "opacity"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.jobStore.title), 1),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", null, [
                        _createElementVNode("span", {
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateEvaluation && _ctx.updateEvaluation(...args))),
                          class: "text-primary bg-white px-4 py-2 hover:bg-gray-100 cursor-pointer"
                        }, "Assign evaluation")
                      ]),
                      _createVNode(_component_router_link, {
                        type: "button",
                        to: `/job-details?id=${_ctx.route.query.id}`,
                        class: "text-primary bg-white px-4 py-2 hover:bg-gray-100"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_13
                        ]),
                        _: 1
                      }, 8, ["to"]),
                      _createVNode(_component_router_link, {
                        type: "button",
                        to: `/edit-job?id=${_ctx.route.query.id}`,
                        class: "text-primary bg-white px-4 py-2 hover:bg-gray-100"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_14
                        ]),
                        _: 1
                      }, 8, ["to"]),
                      _createVNode(_component_Button, {
                        variant: "",
                        label: "Search candidates",
                        onOnClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setShowSearch(!_ctx.showSearch)))
                      })
                    ]),
                    _createVNode(_component_Button, {
                      variant: "outlined",
                      label: "Add candidates",
                      onOnClick: _ctx.createCandidate
                    }, null, 8, ["onOnClick"])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("ul", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobStore &&
                _ctx.jobStore.job_stages &&
                _ctx.jobStore.job_stages.length > 0 &&
                _ctx.jobStore.job_stages, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createElementVNode("li", {
                          class: _normalizeClass(["cursor-pointer py-1 px-4 h-10 transition", index !== 8 ? 'border-gray-200 border-r-2' : '']),
                          onClick: ($event: any) => (_ctx.changeStage(item.stage.name))
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass([
                      _ctx.activeTab === item.stage.name
                        ? 'bg-blue-50 text-black'
                        : ' text-black'
                    , "flex flex-row items-center rounded-lg px-2 py-1"])
                          }, [
                            _createElementVNode("span", _hoisted_17, _toDisplayString(item.stage.name), 1),
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("div", _hoisted_19, _toDisplayString(item.number_candidates), 1)
                            ])
                          ], 2)
                        ], 10, _hoisted_16)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_SearchInput, {
                modelValue: _ctx.inputValue,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.inputValue) = $event)),
                onOnSubmit: _ctx.getData,
                placeholder: "Search for candidates...."
              }, null, 8, ["modelValue", "onOnSubmit"]),
              (
                _ctx.candidates.job_candidates &&
                _ctx.candidates.job_candidates.length > 0
              )
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.candidates.job_candidates &&
                _ctx.candidates.job_candidates.length > 0 &&
                _ctx.candidates.job_candidates, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: _normalizeClass(["rounded cursor-pointer", _ctx.selectedUser === item.id && 'bg-blue-50'])
                      }, [
                        _createElementVNode("div", {
                          onClick: ($event: any) => (_ctx.addAction(item.id)),
                          class: "flex flex-row py-5 px-2"
                        }, [
                          _createElementVNode("div", _hoisted_26, [
                            _createVNode(_component_Avatar, {
                              name: `${item.candidate.first_name} ${item.candidate.last_name}`,
                              size: "s"
                            }, null, 8, ["name"])
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("span", _hoisted_28, _toDisplayString(`${item.candidate.first_name} ${item.candidate.last_name}`), 1),
                            _createElementVNode("span", {
                              class: _normalizeClass([
                        item?.candidate?.position
                          ? 'text-gray-400'
                          : 'text-primary-dark'
                      , "block text-xs w-52 truncate"])
                            }, _toDisplayString(item?.candidate?.position || "No information"), 3),
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("span", _hoisted_30, _toDisplayString(`Added by ${
                            item && item.candidate && item.staff
                              ? `${item.staff.first_name} ${item.staff.last_name}`
                              : "-"
                          } • ${_ctx.timeAgo(item?.candidate?.created_at)}`), 1)
                            ])
                          ])
                        ], 8, _hoisted_25),
                        (index !== _ctx.candidates?.job_candidates?.length - 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_33))
                          : _createCommentVNode("", true)
                      ], 2))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_36))
            ]),
            (_ctx.showOption === '' && !_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  _createVNode(_component_EmptyState, {
                    message: 
                _ctx.candidates?.job_candidates?.length > 0
                  ? 'Select a candidate'
                  : 'No candidates available'
              
                  }, null, 8, ["message"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.toggleInfo === true && _ctx.showOption === 'info')
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _createVNode(_component_CandidateInfo, {
                    userInfo: _ctx.userInfo,
                    onOpenEdit: _ctx.openEdit,
                    onResetSelected: _ctx.resetSelected,
                    onReloadCandidates: _ctx.reloadAllCandidatesStage,
                    onDeleteCandidate: _ctx.openDelete,
                    onReloadOne: _ctx.reloadCandidate,
                    candidateId: _ctx.userInfo?.candidate?.id,
                    key: "create"
                  }, null, 8, ["userInfo", "onOpenEdit", "onResetSelected", "onReloadCandidates", "onDeleteCandidate", "onReloadOne", "candidateId"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.toggleInfo === true && _ctx.showOption === 'edit')
              ? (_openBlock(), _createElementBlock("div", _hoisted_39))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode(_component_ReusableModal, {
      show: _ctx.showModal,
      onClose: _ctx.closeInForm
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AddCandidatesForm, {
          ref: "formRef",
          onCloseModal: _ctx.closeInForm,
          onGetCandidates: _ctx.getFromForm
        }, null, 8, ["onCloseModal", "onGetCandidates"])
      ]),
      _: 1
    }, 8, ["show", "onClose"]),
    _createVNode(_component_ReusableModal, {
      show: _ctx.showDelete,
      onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showDelete = false)),
      size: "w-1/3"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DeleteCandidate, {
          onCloseModal: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showDelete = false)),
          onGetCandidates: _ctx.getFromForm,
          candidateId: _ctx.userInfo.id
        }, null, 8, ["onGetCandidates", "candidateId"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_ReusableModal, {
      show: _ctx.showSearch,
      onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setShowSearch(false))),
      size: "lg:w-1/2 md:w-9/12 w-11/12 bg-background min-h-screen"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AddCandidatesInJob, { onGetCandidates: _ctx.getFromForm }, null, 8, ["onGetCandidates"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_ReusableModal, {
      show: _ctx.showModalTemplate,
      onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setShowModalTemplate(false))),
      size: "lg:w-1/3 md:w-9/12 w-11/12 bg-background min-h-screen"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AddTemplateToJob, {
          id: _ctx.jobStore.id,
          onReload: _ctx.getData,
          onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setShowModalTemplate(false)))
        }, null, 8, ["id", "onReload"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_ReusableModal, {
      show: _ctx.showModalUpgrade,
      onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showModalUpgrade = false)),
      size: "lg:w-1/3 md:w-9/12 w-11/12"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ModalUpgradePlan, {
          onCloseModal: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showModalUpgrade = false))
        })
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}